<h2 class="accent-500 font-weight-900 m-0" mat-dialog-title>
  {{ header_title | translate }}
</h2>
<mat-dialog-content>
  <mat-form-field class="example-full-width">
    <mat-label>{{ placeholder | translate }}:</mat-label>
    <input
      type="text"
      matInput
      #title
      [(ngModel)]="subTitle"
      (input)="enableButton = false; showError = false"
    />
  </mat-form-field>
  <div *ngIf="showError" class="error-message mb-16">
    {{ error_msg | translate }}
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="mb-24">
  <button mat-button class="bg-danger mr-8" (click)="onClickCancel()">
    {{ "Cancel" | translate }}
  </button>
  <button
    mat-button
    class="bg-success"
    [disabled]="subTitle == '' || enableButton"
    (click)="onClickSubmit()"
  >
    {{ "Submit" | translate }}
  </button>
  <button
    mat-button
    mat-dialog-close
    class="dialog-close"
    (click)="onClickCancel()"
  >
    <mat-icon>close</mat-icon>
  </button>
</mat-dialog-actions>
